import { type GetBasketSummaryResponse, useGetBasketSummary } from '@dhl/receiver-consumer-sender-api'

type CachedBasketSummary = {
  data: GetBasketSummaryResponse | undefined
  isLoading: boolean
  isFetching: boolean
}

/**
 * Cached variant of {@link useGetBasketSummary} for use outside the c2c flow (e.g. portal-wide
 * "does the user have basket items?" checks).
 *
 * The basket summary only changes when the user mutates their basket. Every basket mutation
 * already invalidates the basket reads globally (see the receiver-consumer-sender-api mutator),
 * so we can treat the summary as fresh indefinitely and avoid refetching on every mount or
 * navigation. The invalidation on a basket write is what brings the data up to date again.
 */
export const useCachedBasketSummary = (): CachedBasketSummary => {
  const { data, isLoading, isFetching } = useGetBasketSummary({ query: { staleTime: Infinity } })

  return { data, isLoading, isFetching }
}
